import { adaptDataForSubmission } from "@/core/helpers/assessment-submission-adapter";
import { assessmentRequestsTyped } from "@/api/(requests)/assessmentTyped";
import type { AssessmentSubmissionParams, AssessmentSubmissionResponse } from "@/core/types";

export async function postAnswer({
  assessmentDefinitionId,
  assessmentDefinitionVersion,
  formData,
  taskId,
}: AssessmentSubmissionParams): Promise<AssessmentSubmissionResponse> {
  const submissionBody = adaptDataForSubmission({
    assessmentDefinitionId,
    assessmentDefinitionVersion,
    formData,
    taskId,
  });

  return assessmentRequestsTyped.post_answer({
    context: { showLoader: false },
    data: submissionBody,
  });
}
